import TEXT_DATA from '@/common/text'

const mutations = {
  setStatus (state, data) {
    state.status = data
  },
  setQuestion (state, data) {
    state.textData = data
  },
  setCurrentTextLastIndex (state, data) {
    state.currentTextLastIndex = data.roman.length - 1
  },
  setCurrentLetterIndex (state, index) {
    state.currentLetterIndex = index
  },
  setCurrentCorrectLetter (state, index) {
    const currentTextData = state.textData.roman
    state.currentCorrectLetter = currentTextData[index]
  },
  setCurrentTextDataIndex (state, index) {
    state.currentTextDataIndex = index
  },
  setTextDataCount (state, length) {
    state.textDataCount = length
  },
  addWrongLetter (state, letter) {
    const wrongLetterData = state.wrongLetterData
    if (wrongLetterData[letter]) {
      wrongLetterData[letter] += 1
    } else {
      wrongLetterData[letter] = 1
    }
    state.wrongLetterData = wrongLetterData
  }
}

const actions = {
  setStatus ({ commit }, payload) {
    const length = TEXT_DATA[payload.locale].LIST.length
    commit('setTextDataCount', length)
    commit('setStatus', payload.status)
  },
  initializeText ({ commit }, payload) {
    commit('setQuestion', payload.textData)
    commit('setCurrentTextLastIndex', payload.textData)
  },
  setCurrentLetterIndex ({ commit }, payload) {
    commit('setCurrentLetterIndex', payload.letterIndex)
    commit('setCurrentCorrectLetter', payload.letterIndex)
  },
  setCurrentTextDataIndex ({ dispatch, commit }, payload) {
    const textData = TEXT_DATA[payload.locale].LIST[payload.textDataIndex]
    dispatch('initializeText', { textData: textData })
    commit('setCurrentTextDataIndex', payload.textDataIndex)
  },
  addWrongLetter ({ commit }, payload) {
    commit('addWrongLetter', payload.letter)
  },
  setResult ({ commit }, payload) {
    const data = {}
    commit('Result/initialize', data)
  }
}

const state = {
  status: 0,
  nextLetter: '',
  questionNum: 1,
  questionIndex: 0,
  textData: { text: '', hiragana: '', roman: '' },
  currentLetterIndex: 0,
  currentCorrectLetter: '',
  currentTextLastIndex: 0,
  currentTextDataIndex: 0,
  textDataCount: 0,
  wrongLetterData: {}
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/game.js